<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="name"
          :counter="30"
          :rules="nameRules"
          label="Ваше имя"
          prepend-inner-icon="mdi-account-circle"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="phone"
          :rules="phoneRules"
          label="Номер телефона"
          prepend-inner-icon="mdi-phone"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="select1"
          :items="currentBrends"
          @change="changeBrend"
          :rules="[v => !!v || 'Поле Марка машины обязательно для заполнения']"
          label="1. Марка машины"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="select2"
          :disabled="select1 === null"
          :items="currentModel"
          @change="changeModel"
          :rules="[
            v => !!v || 'Поле Модель профиля обязательно для заполнения'
          ]"
          label="2. Модель"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="select3"
          :disabled="select2 === null"
          :items="currentYears"
          @change="changeYears"
          :rules="[v => !!v || 'Поле Год выпуска обязательно для заполнения']"
          label="3. Год выпуска"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="select4"
          :disabled="select3 === null"
          :items="currentModifications"
          label="4. Модификация"
          outlined
          dense
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col class="py-0" cols="12">
        <v-textarea
          v-model="text"
          outlined
          :counter="555"
          :rules="textRules"
          name="input-text"
          label="Комментарии к заказу"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-checkbox
        class="px-2"
        color="success"
        v-model="checkbox"
        :rules="[v => !!v || 'Отметить обязательно!']"
        label="Согласен на обработку своих персональных данных"
        required
      />
    </v-row>

    <v-row justify="center" align="center">
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4 mb-2"
        @click="validate"
        :loading="loading"
        outlined
        text
      >
        Подобрать
      </v-btn>
      <v-btn
        class="mr-4 mb-2"
        color="error"
        @click="reset"
        :loading="loading"
        outlined
        text
      >
        Сбросить
      </v-btn>
    </v-row>
  </v-form>
</template>

<script>
import jsonCars from "@/assets/json/tiresNDisksForm/cars.json";
export default {
  name: "FormTiresNDisks",
  data: () => ({
    loading: false,
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Введите Ваше имя",
      v =>
        (v && v.length <= 30) ||
        "Пожалуйста представьтесь не больше 30 символов"
    ],
    phone: "+7",
    phoneRules: [
      v => !!v || "Номер телефона обязательно для заполнения",
      v =>
        /^\+7\d{10}$/.test(v) ||
        "Введите Ваш номер в следующем формате +79999999999"
    ],
    text: "",
    textRules: [
      v =>
        (v && v.length <= 555) ||
        "Пожалуйста сократите Ваше сообщение до 555 символов"
    ],
    select1: null,
    select2: null,
    select3: null,
    select4: null,
    cars: jsonCars,
    checkbox: false
  }),

  computed: {
    currentBrends() {
      let brends = [];
      this.cars.forEach(car => {
        brends.push(car.brend);
      });
      return brends;
    },
    currentModel() {
      if (this.select1 !== null) {
        let car = this.cars.find(el => {
          return el.brend === this.select1;
        });
        let models = [];
        car.models.forEach(model => {
          models.push(model.name);
        });
        return models;
      } else {
        return [];
      }
    },
    currentYears() {
      if (this.select2 !== null && this.select1 !== null) {
        let car = this.cars.find(el => {
          return el.brend === this.select1;
        });
        let model = car.models.find(mod => {
          return mod.name === this.select2;
        });
        let years = [];
        model.years.forEach(year => {
          years.push(year.year);
        });
        return years;
      } else {
        return [];
      }
    },
    currentModifications() {
      if (
        this.select3 !== null &&
        this.select2 !== null &&
        this.select1 !== null
      ) {
        let car = this.cars.find(el => {
          return el.brend === this.select1;
        });
        let model = car.models.find(mod => {
          return mod.name === this.select2;
        });
        let year = model.years.find(year => {
          return year.year === this.select3;
        });
        let modifications = [];
        year.modifications.forEach(modification => {
          modifications.push(modification);
        });
        return modifications;
      } else {
        return [];
      }
    }
  },

  methods: {
    changeBrend() {
      this.select2 = null;
      this.select3 = null;
      this.select4 = null;
    },
    changeModel() {
      this.select3 = null;
      this.select4 = null;
    },
    changeYears() {
      this.select4 = null;
    },
    validate() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          let emailMessage = {};
          if (this.select4) {
            emailMessage = {
              name: this.name,
              phone: this.phone,
              text: `Пользователь отправил запрос с сайта выбора комплекта по авто:
            Марка: ${this.select1}, Модель: ${this.select2}, Год выпуска: ${this.select3}, Модификация: ${this.select4}.
            Комментарий к заказу: ${this.text}`
            };
          } else {
            emailMessage = {
              name: this.name,
              phone: this.phone,
              text: `Пользователь отправил запрос с сайта выбора комплекта по авто:
            Марка: ${this.select1}, Модель: ${this.select2}, Год выпуска: ${this.select3}, Модификация: не указана.
            Комментарий к заказу: ${this.text}`
            };
          }
          let formData = new FormData();
          formData.append("name", emailMessage.name);
          formData.append("phone", emailMessage.phone);
          formData.append("text", emailMessage.text);
          this.$axios
            .post("https://fivetu-backend.herokuapp.com/emailauto", formData)
            .then(response => {
              this.loading = false;
              this.$store.dispatch("setMessage", {
                type: "success",
                text: response.data
              });
            })
            .catch(err => {
              this.loading = false;
              this.$store.dispatch("setMessage", {
                type: "error",
                text: `Ошибка при отправки письма. ${err.message}`
              });
            });
        } catch (e) {
          this.loading = false;
        }
        this.changeBrend();
        this.select1 = null;
        this.name = null;
        this.phone = null;
        this.text = null;
        this.checkbox = false;
        this.$refs.form.resetValidation();
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped></style>
